export default "__VITE_ASSET__B90wAxV5__"